<template>
<div class="form-group">
    <input
        class="form-control border w-100 bg-transparent"
        :id="id_computed"
        ref="flatpickr"
        :placeholder="placeholder"
        @click="togglePicker"
        @change="updateValue($event.target.value)"
    />
</div>
</template>

<script>
import flatpickr from "flatpickr";

export default {
    name: "FormQuestionDateTime",
    props: {
        id: {
            type: String,
            required: false,
        },
        question: {
            type: Object,
            required: true,
        },
        settings: {
            type: Object,
            required: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        request_form: {
            type: Object,
            required: false,
        },
        placeholder: {
            type: String,
            default: 'Please select a date and time',
        },
    },
    data() {
        return {
            flatpickr_instance: null,
        };
    },
    computed: {
        id_computed() {
            return this.id ?? this.question?.id + '.datetime';
        },
        flatpickr_ref_computed() {
            return this.$refs['flatpickr'];
        },
    },
    mounted() {
        this.flatpickr_instance = flatpickr(this.flatpickr_ref_computed, {
            dateFormat: 'd-m-Y H:i',
            enableTime: true,
            clickOpens: false,
            time_24hr: true,
            defaultDate: this.request_form ? this.request_form[this.id_computed] : Date.now(),
        });

        this.flatpickr_ref_computed.focus = false;
    },
    methods: {
        updateValue(value) {
            this.$emit('update-value', this.id_computed, value);
        },
        togglePicker() {
            this.flatpickr_instance.toggle();
        },
    },
};
</script>
